<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="tcDocumentUploadForm">
        <div class="col-lg-12 col-md-12 table-responsive table-container">
            <div class="card-body scroll">
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Upload Documents
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Upload Documents
                        </p>
                    </div>
                </div>
                <hr>
                
                <div class="row clearfix">
                    <div class="col-sm-12">
                        <div  class="table-responsive min mt-4 ">
                            <div class="container">
                                <table class="table  table-bordered text-nowrap text-left">
                                    <thead>
                                        <tr class="">
                                            <th class="f600">
                                               Sr No
                                            </th>
                                            <th class="f600">
                                             Document Name
                                            </th>
                                            <th class="f600">
                                               File Upload
                                            </th>
                                            <th class="f600">
                                                View
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody id="table_data" formArrayName="newDocumentArray">
                                        <!-- examSemList -->
                                        <tr *ngFor="let fee of getnewDocumentArrayControls(); let i = index; let last = last "
                                            [formGroupName]="i">
                                            <!--  -->
                                            <td class="text-center">
                                                {{i+1}}
                                            </td>
                                            <td>
                                                <input class="form-control input-sm"
                                                    formControlName="DocumentName2">
                                            </td>
                                            <td>
                                                <mat-form-field class="example-full-width" appearance="outline">
                                                    <input type="text" readonly hidden matInput
                                                        formControlName="DocumentFile2" />
                                                    <input type="file" id="i" placeholder="File"
                                                       aria-label="File" formControlName="docFile2"
                                                       [accept]="'.pdf'"
                                                        (change)="onChange($event, i)" onkeydown="return (event.keyCode!=13);"
                                                        class="file-input" />
        
                                                    <!-- <mat-error class="mt-1"
                                                        *ngIf="row?.controls?.DocumentFile?.touched && row?.controls?.DocumentFile?.errors?.required">
                                                        Mandatory
                                                    </mat-error> -->
                                                </mat-form-field>
                                            </td>
                                            <td class="text-center">
                                                <button
                                                type="button"
                                                class="btn btn-sm btn-info"
                                                *ngIf="fee.get('DocumentFile2')?.value"
                                                (click)="viewPdf(i)">
                                                View PDF
                                                </button>

                                            </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="col-sm-12 row ">
                    <div class="col-sm-12 prpl">
                        <button id="Save" type="button" *ngIf="SaveBtn"
                            class="btn btn-primary btn-icon-text floatright mt-1" (click)="save()">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>
                        <button id="Save" type="button" *ngIf="UpdateBtn"
                        class="btn btn-primary btn-icon-text floatright mt-1" (click)="update()">
                        <span style="display: contents; align-items: center;">
                            <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                            Update
                        </span>
                    </button>
                        <button id="Back" type="button" [mat-dialog-close]="true"
                            class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                Back
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>